import React from "react";
import {
  FlexRowBetween,
  ListHolder,
  MediumFont,
  PopupForm,
  RespFont,
} from "../../common/Style";
import CopyText from "../../common/others/CopyText";

const Mis = ({ data }) => {
  return (
    <PopupForm onClick={(e) => e.stopPropagation()}>
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <MediumFont psize={"18px"} csize={"20px"}>
          שגיאות
        </MediumFont>
        {data.length ? (
          <>
            <RespFont style={{ margin: "20px auto" }}>
              במידה וטעות במספר יש לתקן במערכת, במידה ולא - יש לדבר עם האורח
              באופן אישי ולהזין תשובה במערכת
            </RespFont>

            <RespFont style={{ marginBottom: "20px" }}>
              יש ללחוץ על האורח לשם העתקה, לצאת מהחלון הנל ולהדביק בחיפוש כדי
              לתקן
            </RespFont>
            <ListHolder>
              {data.map((item, key) => (
                <FlexRowBetween
                  style={{ marginTop: "10px", justifyContent: "center" }}
                >
                  <CopyText marginLeft={"5px"} dataToCopy={item} text={item} />
                </FlexRowBetween>
              ))}
            </ListHolder>
          </>
        ) : (
          <>
            <RespFont style={{ marginTop: "15px" }}>
              במהלך אישורי ההגעה עלולים להתגלות טעויות במספרים של האורחים, ברגע
              שיהיו, הפעמון יתנדנד ובלחיצה עליו תוכלו לראות את השגיאות על מנת
              לתקן
            </RespFont>

            <RespFont style={{ marginTop: "15px" }}>
              מומלץ להיכנס מידי יום בתהליך אישורי ההגעה על מנת לתקן בזמן ברגע
              שזה קורה
            </RespFont>
          </>
        )}
      </div>
    </PopupForm>
  );
};

export default Mis;
